export class NoviInstance {
  constructor(
    public Name: string,
    public RootUrl: string) { }
}
